import aws from '../../../assets/images/AWS.png'
import azure from '../../../assets/images/Azure.png'
import network from '../../../assets/images/network.png'
import onedrive from '../../../assets/images/OneDrive.png'

export const storageConfigData = [
    {
        name: 'OneDrive',
        type: 'OneDrive',
        config: {
            URL: ''
        }

    },
    {
        name: 'Network',
        type: 'Network',
        config: {
            Directory: ''
        }

    },
    {
        name: 'Azure',
        type: 'Azure',
        config: {
            AzureBlobStorageConnectionString: '',
            AzureBlobStorageContainerName: '',
            AzureBlobStorageEndPoint: ''
        }

    },
    {
        name: 'AWS S3 Bucked',
        type: 'AWS',
        config: {
            AmazonAwsSecretAccessKey: '',
            AmazonAwsAccessKeyId: '',
            AmazonBucketName: '',
            AmazonRegion: ''
        }
    }
]

export function getStorageFieldLabel(configField) {
    switch (configField) {
        case 'Directory': return 'Network Path'
        case 'URL': return 'OneDrive Access Path'

        default: return configField;
    }
}

export function getStorageIcon(type) {
    switch (type) {
        case 'Azure': return azure
        case 'AWS':
        case 'Amazon': return aws;
        case 'Network': return network
        case 'OneDrive': return onedrive

            break;

        default:
            break;
    }
}